import type { JobCardDataFragment } from '../../../graphQL/fragments/__generated__/jobCardData.gqlgenerated';
import type { AppearanceMode } from '../JobCard';

import { Heading } from '../../../../mads';

import { StyleSheet } from 'react-native';

export type JobCardHeadingProps = {
    job: JobCardDataFragment;
    pressed: boolean;
    clickEffectEnabled?: boolean;
    appearanceMode?: AppearanceMode;
};

export function JobCardHeading({
    job,
    pressed,
    clickEffectEnabled,
    appearanceMode,
}: JobCardHeadingProps) {
    return (
        <Heading
            level={4}
            sx={{
                ...styles.title,
                ...(clickEffectEnabled && pressed ? styles.titlePressed : {}),
                ...(appearanceMode === 'default' ? styles.titleDefaultJobCard : {}),
            }}
            numberOfLines={2}
            accessibilityRole="header"
        >
            {job.title}
        </Heading>
    );
}

const styles = StyleSheet.create({
    title: {
        marginBottom: 8,
    },
    titleDefaultJobCard: {
        fontSize: 18,
        fontWeight: 700,
        lineHeight: 24,
    },
    titlePressed: {
        textDecorationLine: 'underline',
    },
});
